import '.ab{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.hn{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ah{justify-content:center;}.ssr-plugin'
import '.aq{align-items:flex-start;}.ssr-plugin'
import '.e7{padding:2rem;}.ssr-plugin'
import '.eb{background:var(--palette-white);}.ssr-plugin'
import '.b3{overflow:hidden;}.ssr-plugin'
import '.bi{position:absolute;}.ssr-plugin'
import '.lm{top:50%;}.ssr-plugin'
import '.ih{right:1rem;}.ssr-plugin'
import '.ln{transform:translateY(-50%);}.ssr-plugin'
import '.lo{width:120px;}.ssr-plugin'
import '.lp{height:120px;}.ssr-plugin'
import '.lq{z-index:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.eo{z-index:1;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.lr{max-width:calc(100% - 140px);}.ssr-plugin'
import '.ls{font-size:4rem;}.ssr-plugin'
import '.cn{font-weight:700;}.ssr-plugin'
import '.lj{line-height:100%;}.ssr-plugin'
import '.hw{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ab n hn d e ah aq e7 eb b3"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bi lm ih ln lo lp lq d t ah"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ab eo d e aq u lr"
      >
        <div className="ls cn lj hw a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
